var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _style, _path, _g, _g2, _path2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTbAppIconAddRobot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_12624",
    width: 24.26,
    height: 17.45,
    "data-name": "Group 12624",
    viewBox: "0 0 24.26 17.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    d: "M35.737 25.664a.957.957 0 1 1 .987-.957.97.97 0 0 1-.987.957",
    className: "cls-1",
    "data-name": "Path 96",
    transform: "translate(-34.75 -23.75)"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_235",
    d: "M0 0h30v30H0z",
    className: "cls-2",
    "data-name": "Rectangle 235"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    d: "M30.724 24.707a.987.987 0 1 1-.987-.957.97.97 0 0 1 .987.957",
    className: "cls-1",
    "data-name": "Path 97",
    transform: "translate(-28.75 -23.75)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    d: "M25.848 28.355c.1.572.225 1.137.35 1.683a9.8 9.8 0 0 0 1.471 3.677c.15.2.524.724.8.724l3.666.011 3.666-.011c.271 0 .645-.524.795-.724a9.8 9.8 0 0 0 1.471-3.677 38 38 0 0 0 .35-1.683l.146-.487a1.47 1.47 0 0 0 .7-1.172c0-.074.046-1.838-.422-1.457-.121.1-.866.752-1.061.881a7.7 7.7 0 0 1-2.487 1.044 14.2 14.2 0 0 1-3.159.409 14.3 14.3 0 0 1-3.159-.409 7.7 7.7 0 0 1-2.487-1.044c-.195-.129-.94-.783-1.061-.881-.473-.381-.427 1.383-.427 1.461a1.47 1.47 0 0 0 .7 1.172m6.43 4.758a.75.75 0 1 1 .777-.749.77.77 0 0 1-.777.749m0-2.275a.75.75 0 1 1 .777-.75.77.77 0 0 1-.777.75",
    "data-name": "Path 98",
    style: {
      fill: "none",
      clipRule: "evenodd"
    },
    transform: "translate(-25 -25.185)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_239",
    d: "M0 0h30v30H0z",
    "data-name": "Rectangle 239",
    style: {
      fill: "none"
    }
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    d: "M30.562 21.454a6 6 0 0 1 .233-1.646l.011-.031a4.58 4.58 0 0 1-2.495-2.027c-.317.085-1.771 1.534-2.561 5.144.98.671 3.087.284 4.92-.258a4.1 4.1 0 0 1-.108-1.182",
    className: "cls-1",
    "data-name": "Path 99",
    transform: "translate(-25.75 -17.75)"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    d: "M35.5 20.41a8.5 8.5 0 0 1 1.685-.324.6.6 0 0 1 .352.084.78.78 0 0 1 .258.718 5.2 5.2 0 0 1-.312 1.426 13 13 0 0 1 1.645.78c-1.032-4.713-2.652-5.344-2.652-5.344.7.486-.227 1.984-.976 2.66",
    className: "cls-1",
    "data-name": "Path 100",
    transform: "translate(-35.5 -17.75)"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    d: "M31.772 18.56a.3.3 0 0 1 .077-.009c.131 0 .355.063 1.03.53.263.181.5.361.614.447h.219A2.37 2.37 0 0 0 35.1 17.5a.8.8 0 0 0-.5-.493c-.12-.041-2.257.044-2.257.044h-.266s-2.1-.083-2.257-.044-.355.183-.315.264a5.45 5.45 0 0 0 1.995 1.496.47.47 0 0 1 .275-.207",
    className: "cls-1",
    "data-name": "Path 101",
    transform: "translate(-29.5 -17)"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    d: "M36.48 23.669a3 3 0 0 1-.828-.6 4.3 4.3 0 0 1-.722-.764l-.034-.134-.145-.012a2.3 2.3 0 0 1-.682-.138l-.169-.111-.114.156a5.9 5.9 0 0 1-1.931.752h-.02a5.45 5.45 0 0 1 .141-2.527c.085-.23.158-.281.179-.291a8.2 8.2 0 0 1 1.886 1.213l.074.058.094-.018a1 1 0 0 1 .178-.014.8.8 0 0 1 .453.122l.083.059.1-.03a11.6 11.6 0 0 1 2.13-.468 1 1 0 0 1 .09.006.54.54 0 0 1 .057.334 5.5 5.5 0 0 1-.822 2.407",
    className: "cls-1",
    "data-name": "Path 102",
    transform: "translate(-31.75 -20)"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#e8e4da}.cls-1{clip-rule:evenodd}.cls-6{clip-path:url(#clip-path-2)}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    d: "M6 10V7H4v3H1v2h3v3h2v-3h3v-2z",
    className: "cls-2",
    "data-name": "Path 1514",
    transform: "translate(-1 -2.275)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TB-APP_icon_Tessa",
    transform: "translate(10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(9.75 6.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    style: {
      clipPath: "url(#clip-path)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(-16.75 -13.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    className: "cls-6",
    "data-name": "Group 364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_234",
    d: "M0 0h11.974v11.914H0z",
    className: "cls-2",
    "data-name": "Rectangle 234",
    transform: "translate(11.75 8.75)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(3.75 6.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(-10.75 -13.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    className: "cls-6",
    "data-name": "Group 368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_236",
    d: "M0 0h11.974v11.914H0z",
    className: "cls-2",
    "data-name": "Rectangle 236",
    transform: "translate(5.75 8.75)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    transform: "translate(0 8.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    style: {
      clipPath: "url(#clip-path-5)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373",
    transform: "translate(-7 -15.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    style: {
      clipPath: "url(#clip-path-6)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_238",
    d: "M0 0h24.26v19.264H0z",
    className: "cls-2",
    "data-name": "Rectangle 238",
    transform: "translate(2 10.185)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(.75 .75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    style: {
      clipPath: "url(#clip-path-7)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377",
    transform: "translate(-7.75 -7.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    className: "cls-6",
    "data-name": "Group 376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_240",
    d: "M0 0h15.056v15.5H0z",
    className: "cls-2",
    "data-name": "Rectangle 240",
    transform: "translate(2.75 2.75)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    transform: "translate(10.5 .75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    style: {
      clipPath: "url(#clip-path-9)"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(-17.5 -7.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    className: "cls-6",
    "data-name": "Group 380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_242",
    d: "M0 0h13.628v15.344H0z",
    className: "cls-2",
    "data-name": "Rectangle 242",
    transform: "translate(12.5 2.75)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    transform: "translate(4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    style: {
      clipPath: "url(#clip-path-11)"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    transform: "translate(-11.5 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    className: "cls-6",
    "data-name": "Group 384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_244",
    d: "M0 0h15.6v12.528H0z",
    className: "cls-2",
    "data-name": "Rectangle 244",
    transform: "translate(6.5 2)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(6.75 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    style: {
      clipPath: "url(#clip-path-13)"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389",
    transform: "translate(-13.75 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    className: "cls-6",
    "data-name": "Group 388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_246",
    d: "M0 0h15.552v13.669H0z",
    className: "cls-2",
    "data-name": "Rectangle 246",
    transform: "translate(8.75 5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbAppIconAddRobot);
export default __webpack_public_path__ + "static/media/tb_app_icon_add_robot.35df59d2c362aab35f5db7cbd7f3e263.svg";
export { ForwardRef as ReactComponent };